<template lang="pug">
.filesSection
	document-asset-list(
		v-if='formValue.folder && formValue.file'
		:documents='formValue.folder'
		:active-files='formValue.file'
	)
	//- the reason why we're using highlight-text as well is to have the border color
	//- be the same as the background
	.drop-box(
		:tabindex='lastTabIndex'
		@keydown.enter='uploadFile'
	)

		.drop-box-wrapper(
			@dragover.prevent
			@drop='dropped'
		)

			.background.highlight-text

			.display-text
				.labels
					p.label.error(v-if='hasErrors') {{ displayError }}
					p.label(v-if='options && options.label' v-html='options.label')
					p.label(v-else) Drop file here or
						span.highlight-text(@click='uploadFile') Choose a file

				.files
					p.file.tooltip(v-for='( file, index ) in localValue' @click='deleteFile( index )') {{ file.name }}
						span.icon-close
						span.tooltipText Click to remove

			input(
				ref='fileUpload'
				type='file'
				v-on:change='changeValue'
			)
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { clone } from '@/lib/utils';
import DocumentAssetList from '../DocumentAssetList';

export default {
	name : 'drop-box',

	props : {
		options : {
			type : Object,
		},

		value : {
			type : [Array, File, String],
		},

		errors : {
			type : [Object, String, Boolean],
		},

		formValue : {
			type : Object,
		},

		field : {
			type : Object,
		},

		form : {
			type : Object,
		},

		lastTabIndex : {
			type : Number,
		}
	},

	data : () => ( {
		localValue : [],

		displayError : null,
	} ),

	computed : {

		hasErrors() {
			return ( typeof this.displayError === 'string' && !!this.displayError );
		},

	},

	watch : {

		localValue( val ) {
			this.displayError = null;

			this.$emit( 'input', val );
		},

		errors( errors ) {
			if ( errors === false ) {
				this.displayError = 'Required';

				return;
			}

			this.displayError = errors;
		},

	},

	methods : {

		uploadFile() {
			this.$refs.fileUpload.click();
		},

		changeValue() {

			const uploadedFile = this.$refs.fileUpload.files[0];

			this.localValue.push( uploadedFile );

		},

		dropped( files ) {
			files.stopPropagation();
			files.preventDefault();

			const allFiles = files.dataTransfer.files;

			const amountOfFiles = Object.keys( allFiles );

			amountOfFiles.forEach( ( key ) => {
				this.localValue.push( allFiles[key] );
			} );
		},

		deleteFile( index ) {
			// console.log( 'deleted', index );
			this.localValue.splice( index, 1 );
		}

	},
	components : {
		DocumentAssetList,
	}
};
</script>

<style lang="scss">
.drop-box {
	position: relative;
	margin-bottom: -20px;

	.drop-box-wrapper {
		position: relative;

		.background {
			border: 2px solid;
			border-left-width: 0;
			border-right-width: 0;
			position: absolute;
			// we get 60px because the form
			// has a padding of 30px on the sides
			width: calc( 100% + 60px );
			left: -30px;
			height: 100%;
		}

		.display-text {
			width: 100%;
			text-align: center;
			color: $input-color;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-flow: column;
			font-weight: 500;
			position: relative;
			padding: 35px 0;
			// the reason why we use margin instead of using padding on the
			// .drop-box is because now if users click on the edge of the
			// box it'll still click this element rather than the parent
			// element receive the click event
			margin: 28px 0;

			p {
				color: $input-color;

				&.error {
					color: $error;
				}

				span {
					position: relative;
					margin-left: 5px;
					cursor: pointer;

					// text-decoration dashed is not widely supported, not even on chrome
					// so we have to be a little hacky with it and have an after element
					// with a border dashed
					&::after {
						content: '';
						position: absolute;
						bottom: 0;
						left: 0;
						width: 100%;
						border: 1px dashed;
					}
				}
			}

			.files {
				display: flex;
				flex-flow: column;
				justify-content: center;
				align-items: center;

				.file {
					margin: 5px 0;
					font-size: 14px;
					width: 150%;
					cursor: pointer;
					margin-block-end: unset;
					margin-block-start: unset;
					&.tooltip {
						position: relative;
						display: inline-block;
						.tooltipText {
							visibility: hidden;
							width: 120px;
							background-color: black;
							color: white;
							text-align: center;
							padding: 5px 0;
							border-radius: 6px;
							position: absolute;
							top: -5px;
							left: 105%;
							z-index: 1;
							// &::after {
							// 	content: "";
							// 	position: absolute;
							// 	top: 50%;
							// 	right: 100%;
							// 	margin-top: -5px;
							// 	border-width: 5px;
							// 	border-style: solid;
							// 	border-color: transparent black transparent transparent;
							// }
						}
						&:hover {
							.tooltipText {
								visibility: visible;
							}
						}
					}

					span {
						top: 3px;
						margin-left: 15px;

						&::after {
							border-width: 0;
							background: crimson;
							width: 2px;
						}
					}
				}
			}
		}

		input {
			display: none;
		}
	}
}
</style>
